export default __webpack_public_path__ + "static/media/step1.9d883a1e.svg";